import { DIALOGS } from '@witmetrics/unison-core';
import { useAppState } from '@/providers/AppStateProvider';
import { stopDefault } from '@/utils/dom';
import { classes } from './utils';

export type AccountButtonProps = {
  name: string;
};

export default function AccountButton({ name }: AccountButtonProps) {
  const { onOpenDialog } = useAppState();

  return (
    <button
      className={classes.account}
      onClick={stopDefault(() => onOpenDialog(DIALOGS.ACCOUNTS))}>
      {name}
    </button>
  );
}
